var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-info"},[_c('div',{staticClass:"avatar"},[_c('div',{staticClass:"avatar-left"}),_c('div',{staticClass:"avatar-right"},[_c('p',[_vm._v(_vm._s(_vm.userInfo.dailyGreeting))]),_c('p',{staticClass:"speech",attrs:{"title":_vm.userInfo.speech}},[_vm._v(_vm._s(_vm.userInfo.speech))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }